<div class="card">
    <div class="card-body">
        <div *ngIf="isForSystemTest" style="color: red; font-weight: bold; font-size: 16px; margin-bottom: 10px;">
            <a><b>Dieser Mandant ist für Systemtests angelegt!</b></a>
            <br><br>
        </div>
        <form [formGroup]="editTenantForm" novalidate>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field style="width: 0; height: 0;">
                        <input matInput hidden  formControlName="id">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Max. Anzahl Mitglieder" formControlName="maxUserCount">
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Max. Anzahl Projekte" formControlName="maxProjectCount">
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Einladung für Mitglieder gültig (Tage)" formControlName="invitationValidForDays">
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <!-- <mat-form-field class="example-full-width">
                        <input matInput placeholder="gebuchte Zusatzmodule" formControlName="additionalModules">
                    </mat-form-field> -->
                    Gebuchte Zusatzmodule (gebucht/verwendet/verfügbar):
                    <div style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; padding: 10px; margin-bottom: 10px;">
                        <a *ngIf="availableModules.length == 0" style="color: black;">- keine Zusatzmodule gebucht -</a>
                        <div *ngIf="availableModules.length > 0">
                            <mat-option  *ngFor="let module of availableModules" [value]="module" >
                                <div (click)="onRowClicked(module)" style="display:flex; align-items:center; justify-content:space-between; width:100%;">
                                    <div style="float:left;">
                                        {{module.moduleName}}
                                    </div>
                                    <div style="float:left; width: 75%;">
                                        {{module.count}}/{{module.usedCount}}/{{module.count - module.usedCount}}
                                    </div>
                                </div>
                            </mat-option>
                        </div>
                    </div>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px"
                        matTooltip="Weitere Module hinzufügen oder entfernen"
                        (click)="addModule()" >Zusatzmodule bearbeiten
                    </button>
                </div>
            </div>

            <br><br>

            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
            (click)="cancel()" >Abbruch</button>
            <!-- <span style="flex: 1 1 auto"></span> -->
            <button mat-raised-button type="submit" class="btn btn-squirrel pull-right" matTooltip="Vertragsadaten speichern"
                (click)="editTenant()">Vertragsdaten speichern</button>
            <div class="clearfix"></div>
        </form>
    </div>
</div> 